
import styled from "@emotion/styled";
import React from "react";
import { A, Bg, Hello, Position, Spanfollow } from "../styles";

const SocialImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 28px
`


const SlideBar = () => {
  return (
    <div>
      <Bg>
        <Position>
          <Hello>
            <Spanfollow>Follow Us</Spanfollow>
            <A
              href="https://hexvoltinu.medium.com/hexvoltinu-power-up-your-next-moonshot-b7677d7b4d97"
              target="blank"
            >
              <SocialImage
                src="/images/medium.png"
              />
            </A>
            <A href="https://t.me/HexVoltInuportal" target="blank">
              <SocialImage
                src="/images/telegram.png"
              />
            </A>
            <A href="https://twitter.com/HexVoltInu" target="blank">
              <SocialImage
                src="/images/twitter.png"
              />
            </A>
          </Hello>
        </Position>
      </Bg>
    </div>
  );
};

export default SlideBar;
